export default __webpack_public_path__ + "static/upiQRCode-f74440921442c87d1874d64eb901c4ac.webm";